const AlertType = {
  Availability: 'AVAILABILITY',
  RollOff: 'ROLL_OFF',
} as const;

export const UserCustomTalentAlertsConst = {
  AlertType,
} as const;
